import * as constants from '../constants/appConstants'

export function formatNumber(_num) {
	return _num.toString().replace(constants.FORMAT_NUMBER_PATTERN, '$1.')
}
